var map = {
	"./custom/app/forbidden/forbidden.component": [
		"wdtk",
		52
	],
	"./rd_senado/app/forbidden/forbidden.component": [
		"2jzp",
		97
	],
	"./rd_senado_cms/app/forbidden/forbidden.component": [
		"FU2x",
		139
	],
	"./rd_senado_faq/app/forbidden/forbidden.component": [
		"L5C5",
		182
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Yvqq";
module.exports = webpackAsyncContext;